import axios from "axios";
import { api } from "../config";
import {
  clearStoredAuthUser,
  configureAxiosInstance,
  getAccessToken,
  getNormalizedApiBaseUrl,
  getStoredAuthUser,
  persistAuthUser,
} from "../utils/backendApi";

axios.defaults.baseURL = getNormalizedApiBaseUrl(api.API_URL);
axios.defaults.headers.post["Content-Type"] = "application/json";
axios.defaults.headers.put["Content-Type"] = "application/json";
axios.defaults.headers.patch["Content-Type"] = "application/json";
const formData = new FormData();

if (getAccessToken()) {
  axios.defaults.headers.common.Authorization = `Bearer ${getAccessToken()}`;
}

configureAxiosInstance(axios, { mode: "payload" });
/**
 * Sets the default authorization
 * @param {*} token
 */
const setAuthorization = (token) => {
  if (token) {
    const current = getStoredAuthUser();
    persistAuthUser({ ...current, access: token });
    axios.defaults.headers.common.Authorization = `Bearer ${token}`;
    return;
  }
  clearStoredAuthUser();
  delete axios.defaults.headers.common.Authorization;
};

class APIClient {
  /**
   * Fetches data from given url
   */

  //  get = (url, params) => {
  //   return axios.get(url, params);
  // };
  get = (url, params) => {
    let response;

    let paramKeys = [];

    if (params) {
      Object.keys(params).map((key) => {
        paramKeys.push(key + "=" + params[key]);
        return paramKeys;
      });

      const queryString =
        paramKeys && paramKeys.length ? paramKeys.join("&") : "";
      response = axios.get(`${url}?${queryString}`, params);
    } else {
      response = axios.get(`${url}`, params);
    }

    return response;
  };
  /**
   * post given data to url
   */
  create = (url, data) => {
    return axios.post(url, data);
  };
  /**
   * Updates data
   */
  update = (url, data) => {
    return axios.patch(url, data);
  };
  /**
   * Delete
   */
  delete = (url, data) => {
    return axios.delete(url, data);
  };
}

const getLoggedinUser = () => {
  return getStoredAuthUser();
};

export { APIClient, setAuthorization, getLoggedinUser };
